import { useState } from "react";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import { API_URL } from "../../config/environment";

import { useNavigate } from "react-router-dom";

export const ActionsMenu = ({
  rowData,
  onStatusChange,
  onSuccess,
  onError,
  onModalChange,
  onGetRowId,
}) => {
  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const token = sessionStorage.getItem("authToken");

  const handleModalChange = () => {
    onGetRowId(rowData._id);
    onModalChange();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  async function updateUser(id, body) {
    const url = `${API_URL}/users/${id}`;
    console.log(token);
    try {
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (response.status === 403) {
        return onError("You are not permitted to update user");
      }

      const data = await response.json();

      if (data.status === "success") {
        onSuccess("User updated successfully");
        navigate("/admin-dashboard");
      } else {
        return onError(data.message);
      }
    } catch (error) {
      return onError("An unexpected error occured");
    }
  }

  const handleChangeStatus = async (body) => {
    // Handle changing status here
    // console.log({ rowData });
    // console.log(`Changing status of item ${rowData._id} to ${body}`);
    await updateUser(rowData._id, body);
    onStatusChange();
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-controls="actions-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="actions-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {rowData.activated ? (
          <MenuItem
            onClick={() => handleChangeStatus({ activated: false })}
            sx={{ color: "red" }}
          >
            Deactivate User
          </MenuItem>
        ) : (
          <MenuItem
            onClick={() => handleChangeStatus({ activated: true })}
            sx={{ color: "black" }}
          >
            Activate User
          </MenuItem>
        )}
        {rowData.subscribed ? (
          <MenuItem
            onClick={() => handleChangeStatus({ subscribed: false })}
            sx={{ color: "red" }}
          >
            Unsubscribe User
          </MenuItem>
        ) : (
          <MenuItem
            onClick={() => handleChangeStatus({ subscribed: true })}
            sx={{ color: "black" }}
          >
            Subscribe User
          </MenuItem>
        )}
        <MenuItem onClick={handleModalChange}>Change Role</MenuItem>
      </Menu>
    </>
  );
};
